import IsaacEmpty from "../../../../components/isaacEmpty/IsaacEmpty";
import type ConstructionCalculationsNewPanelListProps from "./ConstructionCalculationsNewPanelListProps";
import ConstructionCalculationsNewPanelListItem from "../sidePanelListItem/ConstructionCalculationsNewPanelListItem";

const ConstructionCalculationNewPanelList: React.FunctionComponent<ConstructionCalculationsNewPanelListProps> = ({
    calculations,
    isAllowToTakeAction
}) => {
    if (calculations.length > 0) {
    return (
      <>
        {calculations.map(calculation => (
          <ConstructionCalculationsNewPanelListItem
            key={calculation.calculationId}
            calculation={calculation}
            isAllowToTakeAction={isAllowToTakeAction}
          />
        ))}
      </>
    );
  }
  return <IsaacEmpty />;
};

export default ConstructionCalculationNewPanelList;